import { IBooksDetailData } from 'constants/types';

export enum BooksType {
  EBOOK = 'ebook',
  ABOOK = 'abook',
}
export interface IBooksCardProps {
  item: IBooksDetailData
  priorityPreview?: BooksType
}
